(function () {
  function enableDragScroll(el) {
      if (!el || el.dataset.dragScrollReady === 'true') return
      el.dataset.dragScrollReady = 'true'

      let down = false
      let moved = false
      let startX = 0
      let startScroll = 0
      let pointerId = null

      const DRAG_THRESHOLD = 8

      const canDrag = () => el.scrollWidth > el.clientWidth + 1

      const onPointerDown = (e) => {
          moved = false
          if (e.pointerType === 'touch') return // real touch keeps native momentum scroll
          if (e.button !== 0) return // left button only (ignore right/middle click)
          if (!canDrag()) return

          down = true
          startX = e.clientX
          startScroll = el.scrollLeft
          pointerId = e.pointerId

      }

      const onPointerMove = (e) => {
          if (!down || e.pointerId !== pointerId) return
          const dx = e.clientX - startX
          if (!moved && Math.abs(dx) > DRAG_THRESHOLD) {
              moved = true
              el.setPointerCapture?.(e.pointerId)
              el.classList.add('is-grabbing')
          }
          if (moved) {
              e.preventDefault()
              el.scrollLeft = startScroll - dx
          }
      }

      const endDrag = (e) => {
          if (!down || e.pointerId !== pointerId) return
          down = false
          pointerId = null
          el.classList.remove('is-grabbing')
          if (el.hasPointerCapture?.(e.pointerId)) el.releasePointerCapture(e.pointerId)
      }

      const onClick = (e) => {
          if (!moved || !canDrag()) return
          e.preventDefault()
          e.stopPropagation()
          moved = false
      }

      const onDragStart = (e) => e.preventDefault()

      el.addEventListener('pointerdown', onPointerDown, { capture: true })
      el.addEventListener('pointermove', onPointerMove)
      el.addEventListener('pointerup', endDrag)
      el.addEventListener('pointercancel', endDrag)
      el.addEventListener('click', onClick, true)
      el.addEventListener('dragstart', onDragStart)
  }

  function enableScrollArrows(el) {
      if (!el || el.dataset.scrollArrowsReady === 'true') return
      const wrap = el.parentElement
      if (!wrap) return
      const prev = wrap.querySelector('[data-scroll-prev]')
      const next = wrap.querySelector('[data-scroll-next]')
      if (!prev && !next) return
      el.dataset.scrollArrowsReady = 'true'

      const canScroll = () => el.scrollWidth > el.clientWidth + 1

      const update = () => {
          const scrollable = canScroll()
          wrap.classList.toggle('has-scroll-arrows', scrollable)
          if (!scrollable) {
              prev?.classList.add('is-hidden')
              next?.classList.add('is-hidden')
              return
          }
          const atStart = el.scrollLeft <= 2
          const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 2
          prev?.classList.toggle('is-hidden', atStart)
          next?.classList.toggle('is-hidden', atEnd)
      }

      const step = () => Math.max(el.clientWidth * 0.8, 120)
      prev?.addEventListener('click', () => el.scrollBy({ left: -step(), behavior: 'smooth' }))
      next?.addEventListener('click', () => el.scrollBy({ left: step(), behavior: 'smooth' }))

      el.addEventListener('scroll', update, { passive: true })
      if ('ResizeObserver' in window) {
          const ro = new ResizeObserver(() => update())
          ro.observe(el)
      }
      update()
  }

  function initDragScroll(root = document) {
      root.querySelectorAll('[data-drag-scroll]').forEach(enableDragScroll)
      root.querySelectorAll('[data-scroll-arrows]').forEach(enableScrollArrows)
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initDragScroll(); });
  } else {
    initDragScroll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initDragScroll(e.target || document);
  });

  window.initDragScroll = initDragScroll;
})();
